/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import customerSubscriptionFieldsetTemplate from './customer-subscription-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function CustomerSubscriptionDirective($compile, $templateCache) {
    var linker = function (scope, element) {
        var template = $templateCache.get(customerSubscriptionFieldsetTemplate);
        element.html(template);
        $compile(element.contents())(scope);
    }
    return {
        restrict: "E",
        link: linker,
        scope: {
            customerSubscription: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/customer/subscription/customer-subscription.directive.js